export default "__VITE_ASSET__c70837fc__"